export const dummyTitle = ['Image', 'Name', 'Keywords', 'Science Index', ""];

export const dummyArticles = [
	{
		articles: [
			{
				title:
					'What is that',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
			{
				title:
					'A less harmful system of preparing robust fabrics for integrated self-cleaning, oil-water separation and water purification',
				journal_title: 'Environmental pollution (Barking, Essex : 1987)',
				authors: 'Maiping Yang, Chi Jiang, Weiqu Liu, Liyan Liang, Ke Pi',
				summary:
					'Although the development of constructing oil-water separation materials is quick, the defects of using harmful regents, weak stability and single function still exist. Here, we report an effective and less-harmful system with poly-dimethylsiloxane (PDMS)/ZnO composite solution to fabricate robust superhydrophobic surfaces for oil-water separation and removal of organic pollutant. The obtained samples were characterized by a range of instruments. The water contact angle (WCA) of coated cotton was 155.6°, whi',
				link_url: 'https://doi.org/10.1016/j.envpol.2019.113277',
				link_url_check: 'NONE',
				year: 2012,
				lang: 'en',
				keywords: ['water', 'robust', 'oil', 'regents weak', 'superhydrophobic'],
				Taxon_ids: [80489],
				science_index: 'Nanoparticles;Porosity;Textiles;Ultraviolet Rays;Water;Water Purification',
			},
		],
		taxa_id: 80489,
		cname: 'Here',
		sname: 'Here',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/7f/d4/f4/542.4071919458.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
];


// if (searchList.length > 0) {
// 	let firstKeyword = searchList.shift();
// 	let firstArray = [];

// 	firstKeyword.keyword.map((item, index) => {
// 		let itemValue = this.getSearchName(item);
// 		let newCard = this.makeCard(itemValue, index, 0);
// 		firstArray.push(newCard);
// 		this.props.addNewCard('C', newCard, this.props.modifyCard);
// 	});

// 	let prevCardList = [];
// 	searchList.map((v, k) => {
// 		let title = this.getSearchName(v.keyword);

// 		if (k == 0) {
// 			prevCardList = firstArray;
// 		}

// 		let nowCardList = [];

// 		title.map((item, index) => {
// 			let itemValue = this.getSearchName(item);
// 			let newCard = this.makeCard(
// 				itemValue,
// 				index,
// 				k + 1,
// 				prevCardList,
// 			);
// 			nowCardList.push(newCard);
// 			this.props.addNewCard('C', newCard, prevCardList);
// 		});

// 		prevCardList = nowCardList;
// 	});

// 	this.props.onClose();
// }